(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-product-tabs"] && !Shopify.designMode) return;
  try {
    

  (function () {

    if (window.__productTabsSectionBound) return;

    window.__productTabsSectionBound = true;



    function renderVideo(scope) {

      const root = scope || document;

      root.querySelectorAll('.video-open-popup:not([data-video-bound])').forEach((videoOpenPopup) => {

        videoOpenPopup.dataset.videoBound = 'true';

        videoOpenPopup.addEventListener('click', function (e) {

          e.preventDefault();

          const videoId = videoOpenPopup.dataset.videoId;

          const videoWrapper = document.querySelector('.video-modal__content-block');

          if (!videoWrapper || !videoId) return;

          videoWrapper.innerHTML = `<iframe width="100%" src="https://www.youtube.com/embed/${videoId}?si=6yJ56P_BJEG5d2Uq" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>`;

        });

      });

    }



    function ensureVideoModal() {

      if (document.getElementById('PopupModal-product-tabs-video')) return;

      document.body.insertAdjacentHTML(

        'beforeend',

        `<side-drawer class="popup__content video-modal drawer fixed top-0 left-0 z-9 w-screen h-full flex justify-center no-js-hidden" id="PopupModal-product-tabs-video" data-moved="true">

          <div class="drawer__overlay fixed inset-0 cursor-pointer"></div>

          <div class="popup__inner color-scheme-1 popup__inner--video w-auto h-full absolute-c-c flex flex-column global-settings-popup">

            <div class="popup__inner--content relative w-full h-full overflow-auto cus-scrollbar">

              <div class="video-modal__content-block">Video</div>

              <button onclick="this.closest('side-drawer').close()" class="button button-unstyled close-button popup__close minimum-touch-target-before drawer__close block t-button bor-none rounded-full cursor-pointer absolute" type="button" aria-label="Close dialog" style="--top: 0.3rem; --right: 0.3rem">

                <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-close" viewBox="0 0 18 17"><path fill="currentColor" d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"></path></svg>

              </button>

            </div>

          </div>

        </side-drawer>`

      );

    }



    function openAccordionTab(tabContent) {

      const section = tabContent.closest('.section-product-tabs');

      if (!section) return;

      section.querySelectorAll('.style-accordion .toggle-title.is-open').forEach((el) => el.classList.remove('is-open'));

      tabContent.querySelector('.toggle-title')?.classList.add('is-open');

    }



    function closeAccordionTab(tabContent) {

      tabContent.querySelector('.toggle-title')?.classList.remove('is-open');

    }



    document.addEventListener('click', function (e) {

      const section = e.target.closest('.section-product-tabs');

      if (!section) return;



      const tabTitle = e.target.closest('.tab-title');

      if (tabTitle && section.contains(tabTitle)) {

        e.preventDefault();

        const tabList = section.querySelector('.tabs-list');

        if (!tabList) return;

        const tabTitles = [...tabList.querySelectorAll('.tab-title')];

        const tabContents = [...section.querySelectorAll('.product-tabs-tab .tabs-content > .tab-content')];

        const index = tabTitles.indexOf(tabTitle);

        if (index === -1 || tabTitle.classList.contains('is-active')) return;

        tabTitles.forEach((t) => t.classList.remove('is-active'));

        tabContents.forEach((c) => c.classList.remove('is-active'));

        tabTitle.classList.add('is-active');

        setTimeout(() => {

          const content = tabContents[index];

          if (!content) return;

          content.classList.add('is-animating', 'is-active');

          content.addEventListener(

            'transitionend',

            function handler() {

              content.classList.remove('is-animating');

              content.removeEventListener('transitionend', handler);

            },

            { once: true }

          );

        }, 10);

        return;

      }



      const toggleLink = e.target.closest('.toggle-link');

      if (!toggleLink || !section.contains(toggleLink)) return;

      e.preventDefault();



      const toggleTitle = toggleLink.closest('.toggle-title');

      if (!toggleTitle) return;



      const tabTitleText = document.querySelector('.tab-title-text');

      if (tabTitleText) tabTitleText.textContent = toggleLink.textContent;



      const viewContentType = toggleTitle.dataset.viewContent;

      const content = toggleTitle.nextElementSibling;

      if (!content) return;



      if (Shopify?.designMode && section.querySelector('.style-accordion')) return;



      switch (viewContentType) {

        case 'sidebar': {

          const drawerContent = document.querySelector('#Global-Drawer .drawer__wrapper');

          if (drawerContent) {

            drawerContent.innerHTML = '';

            drawerContent.appendChild(content.cloneNode(true));

            renderVideo(drawerContent);

          }

          break;

        }

        case 'popup': {

          const popupContent = document.querySelector('.popup-content-wrapper');

          if (popupContent) {

            popupContent.innerHTML = '';

            popupContent.appendChild(content.cloneNode(true));

            renderVideo(popupContent);

          }

          break;

        }

        default:

          toggleTitle.classList.toggle('is-open');

      }

    });



    if (Shopify?.designMode) {

      document.addEventListener('shopify:block:select', function (e) {

        const tabContent = e.target.closest('.section-product-tabs .tab-content');

        if (!tabContent) return;

        openAccordionTab(tabContent);

      });



      document.addEventListener('shopify:block:deselect', function (e) {

        const tabContent = e.target.closest('.section-product-tabs .tab-content');

        if (!tabContent) return;

        closeAccordionTab(tabContent);

      });

    }



    document.addEventListener('DOMContentLoaded', function () {

      ensureVideoModal();

      renderVideo();

    });

  })();


  } catch(e) { console.error(e); }
})();
})();
